<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M7.95605 8.875C7.95605 8.46079 8.29184 8.125 8.70605 8.125H10.9561C11.3703 8.125 11.7061 8.46079 11.7061 8.875V11.125C11.7061 11.5392 11.3703 11.875 10.9561 11.875H8.70605C8.29184 11.875 7.95605 11.5392 7.95605 11.125V8.875Z" 
    fill="currentColor" />
    <g opacity="0.68">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.83105 4C6.51734 4 3.83105 6.68629 3.83105 10C3.83105 13.3137 6.51734 16 9.83105 16C13.1448 16 15.8311 13.3137 15.8311 10C15.8311 6.68629 13.1448 4 9.83105 4ZM2.33105 10C2.33105 5.85786 5.68892 2.5 9.83105 2.5C13.9732 2.5 17.3311 5.85786 17.3311 10C17.3311 14.1421 13.9732 17.5 9.83105 17.5C5.68892 17.5 2.33105 14.1421 2.33105 10Z" 
      fill="currentColor" />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PauseCircleIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>